import { Flex, Heading } from '@chakra-ui/react';
import Layout from '../../Components/Templates/Layout';
import CertificationBanner from '../../Components/CertificationBanner';
import SectorsCarousel from '../../Components/SectorsCarousel';

const Home = () => { 
    return (
        <Layout topBarMaxWidth={ 1400 } contentFlexDirection='column'>
            <Flex maxHeight='400px' flex='1'>
                <SectorsCarousel />
            </Flex>
            <Flex>
                <CertificationBanner />
            </Flex>
        </Layout>
    );
};

export default Home;